/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://gis.clark.wa.gov/portal/jsapi/jsapi4/esri/copyright.txt for details.
*/
import{progressiveLoadingModulo as e}from"./TerrainConst.js";import{TileAgent as r}from"./TileAgent.js";class t extends r{constructor(){super(),this.type="map",this._scaleRangeEnabled=!0}get _desiredMinLevelDelta(){return 0}get _progressiveLevelModulo(){return e}}function s(e){return"map"===e.type}export{t as MapTileAgent,s as isMapTileAgent};
